import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "@actions/actionCreators";

type Args = {
  spaceId: number;
  id: string;
};

const [useDeleteProduct, deleteProduct] = createAsyncAction(
  "products/delete",
  async ({ spaceId, id }: Args) => {
    const res = await API.call<{ product: string }>({
      endpoint: `spaces/${spaceId}/products/${id}`,
      method: "DELETE",
    });
    return { ...res, result: res.result.product };
  }
);

export default useDeleteProduct;
export { deleteProduct };
